import React from 'react'
import { useSelector } from 'react-redux'
import getPercentage from '../../../lib/functions/getPercentage'

const ResultsListItem = ({
    rank,
    data
}) => {
    const { resultItem, participant, result, max } = data
    const resultItemName = useSelector(state => state.resultItems.items[resultItem].name)
    const participantName = useSelector(state => state.participants.items[participant].name)

    return (
        <tr className="jm-results-list-item grid-container" role="row">
            <td role="cell" className="grid-item rank">{rank}</td>
            <td role="cell" className="grid-item percent">{getPercentage(result, max, 2)}%</td>
            <td role="cell" className="grid-item resultItem">{resultItemName}</td>
            <td role="cell" className="grid-item participant">{participantName}</td>
        </tr>
    )
}

export default ResultsListItem
